import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const BurgerMenu: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper 
    onClick={onClick}
    divClassName={divClassName}
  >
    <svg 
      width="26" 
      height="30" 
      viewBox="0 0 26 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0 16V14H26V16H0ZM0 9V7H26V9H0ZM0 2V0H26V2H0Z" 
        fill="#3273E1"
      />
    </svg>
  </SvgWrapper>
);

